import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react'
import { analytics } from 'analytics'
import { useState } from 'react'

import { HttpStatus } from 'enums'
import { ClientAccountDto } from 'types/dto/ClientAccount.dto'

import { paveApi } from 'api'
import { Box, Button, Dropdown, Text } from 'components/common'
import CheckList, {
  ChecklistOption,
} from 'components/common/CheckList/CheckList'
import FlexBox from 'components/common/FlexBox/FlexBox'
import ModalLoader from 'components/common/Loader/ModalLoader'
import { DropdownOptionString } from 'components/partials/DropdownWithTags'
import {
  LINK_SUB_ACCOUNT_TO_GROUP_MODAL_SUBMITTED,
  LINK_SUB_ACCOUNT_TO_GROUP_MODAL_SUBMITTED_FAILED,
  LINK_SUB_ACCOUNT_TO_GROUP_MODAL_SUBMITTED_SUCCESS,
} from 'constants/track.constants'
import { useCustomToast } from 'hooks/useCustomToast'
import { old_COLOR } from 'styles/constants/old_color'
import { old_FONT_SIZE } from 'styles/constants/old_fontSize'
import { old_SPACE } from 'styles/constants/old_space'

type Props = {
  isOpen: boolean
  onClose: () => void
  selectedAccounts: ChecklistOption[]
  setSelectedAccounts: React.Dispatch<React.SetStateAction<ChecklistOption[]>>
  clientAccounts: ClientAccountDto[]
  refetch: () => void
}
function SubAccountGroupAssignmentModal({
  isOpen,
  onClose,
  selectedAccounts,
  setSelectedAccounts,
  clientAccounts,
  refetch,
}: Props) {
  const [selectedClientAccount, setSelectedClientAccount] = useState<
    any | null
  >(null)

  const { showErrorToast, showSuccessToast, showViewOnlyDefaultToast } =
    useCustomToast()

  const [linkSubAccount, { isLoading }] = paveApi.useLinkSubAccountMutation()
  const clientAccountOptions = clientAccounts?.map((c) => {
    return {
      value: c.id,
      label: c.displayName,
    }
  }) as DropdownOptionString[]

  const handleSave = () => {
    analytics.track(LINK_SUB_ACCOUNT_TO_GROUP_MODAL_SUBMITTED)
    if (selectedClientAccount) {
      linkSubAccount({
        id: selectedClientAccount?.value,
        body: {
          managementOrganizationAccountIds: selectedAccounts.map(
            (account) => account.value
          ),
        },
      })
        .unwrap()
        .then((response) => {
          if (response.status === 'Error') {
            analytics.track(LINK_SUB_ACCOUNT_TO_GROUP_MODAL_SUBMITTED_FAILED)
            showErrorToast('Error linking account')
          } else {
            analytics.track(LINK_SUB_ACCOUNT_TO_GROUP_MODAL_SUBMITTED_SUCCESS)
            onClose()
            showSuccessToast('Account linked')
            refetch()
          }
        })
        .catch((e) => {
          analytics.track(LINK_SUB_ACCOUNT_TO_GROUP_MODAL_SUBMITTED_FAILED)
          if (e?.status === HttpStatus.FORBIDDEN) {
            showViewOnlyDefaultToast()
          } else {
            showErrorToast('Error linking account')
          }
        })
    }
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay bg="rgba(0, 0, 0, 0.2)" />
      <ModalContent>
        <ModalHeader>
          <Box>
            <Text color={old_COLOR.coolGray600} fontSize={old_FONT_SIZE.fs16}>
              Assign to Group
            </Text>
          </Box>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody paddingX={old_SPACE.sp24}>
          <Dropdown
            label="Group"
            placeholder="Select"
            options={clientAccountOptions}
            onChange={(option: unknown) => setSelectedClientAccount(option)}
            value={selectedClientAccount}
          />
          <FlexBox
            flexDirection="column"
            gap={old_SPACE.sp8}
            marginTop={old_SPACE.sp10}
            maxHeight="20rem"
            position="relative"
            overflow="hidden"
          >
            <CheckList
              allOptions={selectedAccounts}
              headerLabel="Selected Accounts"
              selectedOptions={selectedAccounts}
              setSelectedOptions={setSelectedAccounts}
            />
          </FlexBox>
        </ModalBody>
        <ModalFooter marginBottom={old_SPACE.sp8}>
          <Box marginBottom={old_SPACE.sp12} width="100%">
            <Button
              onClick={handleSave}
              size="md"
              variant="primary"
              width="100%"
              disabled={
                !selectedClientAccount || isLoading || !selectedAccounts.length
              }
            >
              Save
            </Button>
            {isLoading && <ModalLoader />}
          </Box>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
export default SubAccountGroupAssignmentModal
